import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setDefaultCard } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useSetDefaultCard({
  handleSuccess = () => null,
  handleError = () => null,
} = {}) {
  const queryclient = useQueryClient();
  const Request = useMutation({
    mutationFn: setDefaultCard,
    mutationKey: ['setDefaultCard'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        handleError();
        return toastEmitter('error', responseData?.error?.message);
      }
      handleSuccess();
      queryclient.invalidateQueries(['getSavedCardsList']);
      toastEmitter('success', responseData?.data?.message);
    },
  });
  return { ...Request };
}
